import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { FieldRow, SegmentedControl } from '@/core/ui';
import { basemapAtom } from './basemapAtom';

export function BasemapField() {
  const { t } = useTranslation('basemap');
  const [basemap, setBasemap] = useAtom(basemapAtom);
  return (
    <FieldRow group label={t('label')}>
      <SegmentedControl
        compact
        className="min-w-[130px]"
        options={[
          { value: 'default', label: t('default') },
          { value: 'satellite', label: t('satellite') },
        ]}
        value={basemap}
        onChange={setBasemap}
      />
    </FieldRow>
  );
}
